import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

// State
export type LocationState = LocationData;

// Initial State
export const initialState: LocationState = {
  payload: {
    pageAlias: null,
    slug: null,
  },
};

// Reducers
const setPageAlias: CaseReducer<LocationState, PayloadAction<string>> = (state, action) => {
  if (action.payload) {
    state.payload.pageAlias = action.payload;
  }
};

// Slice
const slice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setPageAlias,
  },
});

// Export: Actions
export const actions = slice.actions;

// Export: Reducer
export default slice.reducer;

// Selectors
const selectSelf = (state: LocationState) => state;
export const selectors = {
  self: selectSelf,
  pageAlias: (state: LocationState) => state.payload.pageAlias,
};
